import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Tasks } from "../interfaces/home/tasks.interface";
import { DashboardTaskAlertTypes, getAlertDisplay } from "../enums/Tasks.enum";

@Injectable({ providedIn: "root" })
export class LandingPageTaskService {
    tasksDetails: BehaviorSubject<Tasks[]> = new BehaviorSubject<Tasks[]>([])
    taskName: BehaviorSubject<string> = new BehaviorSubject<string>("")

    setTasksDetails(data: Tasks[]){
        this.tasksDetails.next(data);
    }

    getTasksDetails(): Tasks[]{
        return this.tasksDetails.value
    }

    setTaskName(taskName: string){
        this.taskName.next(taskName);
    }

    getTaskName(): string{
        return this.taskName.value
    }
    
    updateTasksDetailsValue(data: Tasks, alertType?: DashboardTaskAlertTypes){
        if (alertType) {
            const taskName = getAlertDisplay(alertType);
            const tasks = this.tasksDetails.value;
            const index = tasks.findIndex(item => 
              item.title?.trim().toLowerCase() === taskName?.trim().toLowerCase()
            );
            tasks[index] = data;
            this.tasksDetails.next(tasks);  
        }     
    }
}